// After a deploy every open tab reloads onto the new build: a fresh index.html names its main bundle, and when that
// isn't the one this tab runs, the tab reloads. Checked every two minutes and when the tab comes back; never while a
// Harbour Rush run is on screen.
const BUNDLE = /\/static\/js\/main\.\w+\.js/;

export function watchBuild() {
  const mine = document.querySelector('script[src*="/static/js/main."]')?.getAttribute("src")?.match(BUNDLE)?.[0];
  if (!mine) return;
  let stale = false;
  const check = async () => {
    if (!stale) {
      const html = await fetch(`/?build=${Date.now()}`, { cache: "no-store" }).then((r) => r.text()).catch(() => "");
      const live = html.match(BUNDLE)?.[0];
      stale = Boolean(live && live !== mine);
    }
    if (stale && !document.querySelector('[data-testid="rush-score"], [data-testid="rush-start"]')) window.location.reload();
  };
  setInterval(check, 120000);
  document.addEventListener("visibilitychange", () => document.visibilityState === "visible" && check());
}
